export default __webpack_public_path__ + "static/media/army.4d79ee6e.png";